module.exports = __webpack_public_path__ + "img/ongoing-notifications-bg.webp";